import { ColumnsMultipleOutputsParams } from '../performance_metrics/config/rowConfig/types';

const rowTransformerCalibrationOutputs = (data: ColumnsMultipleOutputsParams | undefined) => {
  const firstColumn = {
    ltm_revenue_multiple_outputs: {
      value: data?.ltm_revenue_multiple ?? 0,
      id: 'ltm_revenue_multiple_outputs',
    },
    ntm_revenue_multiple_outputs: {
      value: data?.ntm_revenue_multiple ?? 0,
      id: 'ntm_revenue_multiple_outputs',
    },
    ltm_ebitda_multiple_outputs: {
      value: data?.ltm_ebitda_multiple ?? 0,
      id: 'ltm_ebitda_multiple_outputs',
    },
    ntm_ebitda_multiple_outputs: {
      value: data?.ntm_ebitda_multiple ?? 0,
      id: 'ntm_ebitda_multiple_outputs',
    },
    revenue_premium_formula_selector: {
      value: data?.revenue_premium_formula_selector ?? 0,
      id: 'revenue_premium_formula_selector',
    },
    ebitda_premium_formula_selector: {
      value: data?.ebitda_premium_formula_selector ?? 0,
      id: 'ebitda_premium_formula_selector',
    },
  };

  return [firstColumn];
};

export default rowTransformerCalibrationOutputs;
